import {createApp, ref} from 'vue'
import App from './App.vue'
import ImageSelectCheckbox from "@/components/settings_element/image_select_checkbox/ImageSelectCheckbox";
import ImageSelectRadio from "@/components/settings_element/image_select_radio/ImageSelectRadio.vue";
import ColorSelectRadio from "@/components/settings_element/color_select_radio/ColorSelectRadio.vue";
import FontSelectRadio from '@/components/settings_element/font_select_radio/FontSelectRadio.vue';
import Coordinates from "@/components/settings_element/coordinates/Coordinates.vue";
import Date from "@/components/settings_element/date/Date.vue";
import Location from "@/components/settings_element/location/Location.vue";
import Place from "@/components/settings_element/place/Place.vue";
import Text from "@/components/settings_element/text/Text.vue";
import Textarea from "@/components/settings_element/textarea/Textarea.vue";
import Time from "@/components/settings_element/time/Time.vue";
import ProductDetail from "@/components/settings_element/product_detail/ProductDetail.vue";
import BorderPreview from "@/preview/components/Border";
import BorderStarMapPreview from "@/preview/components/BorderStarMap";
import FramePhysicalPreview from "@/preview/components/FramePhysical";
import TextElementPreview from "@/preview/components/TextElement";
import StarMapPreview from "@/preview/components/StarMapPreview";
import PosterBackground from "@/preview/components/PosterBackground";
import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/antd.less';
import wNumb from "wnumb";

var currency_position = window.nse_config.product_info.currency_position;
if (!currency_position) currency_position = 'right';
window.nse_number_format = wNumb({
    mark: window.nse_config.product_info.decimal_separator,
    thousand: window.nse_config.product_info.thousand_separator,
    decimals: window.nse_config.product_info.number_of_decimal,
    prefix: currency_position === 'left' ? window.nse_config.product_info.currency + ' ' : '',
    suffix: currency_position === 'right' ? " " + window.nse_config.product_info.currency : ''
});

window.buildNumber = process.env.VUE_APP_BUILD_NUMBER;
window.nse_app = {
    right_panel_width: 420,
    star_map_width_mobile: 700,
    star_map_width_desktop: 700,
    StarMap: false,
    starMapPreviewId: "nse-preview-svg"
}
window.nse_config.star_width = 700;

const appInit = createApp(App);

appInit.component('nse-image-select-radio', ImageSelectRadio);
appInit.component('nse-image-select-checkbox', ImageSelectCheckbox);
appInit.component('nse-color-select-radio', ColorSelectRadio);
appInit.component('nse-font-select-radio', FontSelectRadio);
appInit.component('nse-coordinates', Coordinates);
appInit.component('nse-date', Date);
appInit.component('nse-location', Location);
appInit.component('nse-place', Place);
appInit.component('nse-text', Text);
appInit.component('nse-textarea', Textarea);
appInit.component('nse-time', Time);
appInit.component('nse-product-detail', ProductDetail);

//ForMarPreview
appInit.component('star-map-preview', StarMapPreview);
appInit.component('border-preview', BorderPreview);
appInit.component('border-starmap-preview', BorderStarMapPreview);
appInit.component('frame-physical-preview', FramePhysicalPreview);
appInit.component('text-preview', TextElementPreview);
appInit.component('poster-background', PosterBackground);

appInit.provide('$bus', event);
appInit.use(Antd);

var appLanguage = {
    ERROR_LATITUDE: "Latitude not correct",
    ERROR_LONGITUDE: "Longitude not correct",
    ADD_TO_CART: 'Add to cart',
    SAVE_FOR_LATER: 'Save for later',
    HEADER_QNA_TITLE: "Customize you personal Design",
    HEADER_QNA_DESCRIPTION: "and catch your magical moment!",
    MODEL_EMAIL_TITLE: "Save your star map",
    MODEL_EMAIL_DESCRIPTION: "This form collects your email address so that we can send you a digital copy of your star map print to your email. You will be able to continue with your star map design later.",
    REQUIRED: "REQUIRED",
    MODEL_EMAIL: "Email",
    MODEL_EMAIL_IS_REQUIRE: "Email not empty",
    MODEL_EMAIL_INVALID: "Please enter a valid email",
    READ_POLICY: "I read and agree to the Privacy Policy.",
    BUTTON_SEND_EMAIL: "Save my design",
    CONTINUE_EDIT: "Continue Edit",
    CHECKOUT: "Checkout",
    MODEL_CONFIRM_PLACE: "Location",
    MODEL_CONFIRM_MESSAGE: "Message",
    MODEL_CONFIRM_TITLE: "Title",
    MODEL_CONFIRM_DATE: "Date",
    MODEL_CONFIRM_COORDINATES: "Coordinates",
    MODEL_CONFIRM_TEXT_COUNTRY: "Text Country",
    MODEL_CONFIRM_TEXT_CITY: "Text City",
    YOUR_EMAIL: "Your Email",
    EDIT: 'ON',
    LOCK: 'OFF',
    SAVE_MESSAGE: "Save message",
    INSPIRATION: "Inspiration",
    INSPIRATION_DESC: "Choose your category and get inspired.",
    FIND_INSPIRATION: "Find your sayings here.",

    REVERSION_TITLE: "Reversion",
    REVERSION_DESC: "Your reversion",
    REVERSION_NEW_DESIGN: "Create New",
    REVERSION_CONTINUE: "Continue edit",

    PRINT_STYLE: "Print Style",
    PRINT_LAYOUT: "Print Layout",
    PRINT_SIZE: "Print Size",

    NEXT_STEP: "Next step",
    NEXT_STEP_BUTTON: "Next step",

    MOBILE_DOUBLE_CHECK_PREVIEW: "Please make sure to double check your details before placing your star map to the cart!",

    SETTING_BACKGROUND_COLOR: "Background Color",
    INPUT_ERROR_REQUIRE: "Please input here",
    TOTAL: "Total"
}

if (window.nse_i18n) {
    appLanguage = Object.assign({}, appLanguage, window.nse_i18n)
}

if (!window.nse_config.pricing) {
    console.log("No pricing config")
}

if (!window.nse_config.fields_show_price) {
    window.nse_config.fields_show_price = ["size", "poster_frame"];
}

appInit.config.globalProperties.LANG = appLanguage;
appInit.config.globalProperties.store = ref({});
if (nse_config.edittoggle) {
    appInit.config.globalProperties.store.value = nse_config.edittoggle;
}
appInit.config.globalProperties.collapse_status = ref({});

const $nl2br = (str, is_xhtml) => {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
appInit.provide('$nl2br', $nl2br);

appInit.mount('#app');
